import React from 'react';
import { formatFilterOptionLabel } from './filterHelpers';

export interface FilterGroup {
  label: string;
  values: string[];
  setValues: (values: string[]) => void;
}

interface AppliedFiltersProps {
  /** @deprecated Use filterGroups instead */
  statusFilters?: string[];
  /** @deprecated Use filterGroups instead */
  setStatusFilters?: (statuses: string[]) => void;
  filterGroups?: FilterGroup[];
}

export const AppliedFilters: React.FC<AppliedFiltersProps> = ({
  statusFilters,
  setStatusFilters,
  filterGroups,
}) => {
  const groups: FilterGroup[] =
    filterGroups ??
    (statusFilters && setStatusFilters
      ? [
          {
            label: 'Status',
            values: statusFilters,
            setValues: setStatusFilters,
          },
        ]
      : []);

  const allFilters = groups.flatMap((g) =>
    g.values.map((v) => ({
      ...g,
      value: v,
      remove: () => g.setValues(g.values.filter((s) => s !== v)),
    })),
  );

  const resetAll = () => groups.forEach((g) => g.setValues([]));

  if (allFilters.length === 0) return null;

  return (
    <div className="mb-2 flex flex-wrap items-center gap-2">
      {allFilters.map(({ label, value, remove }) => (
        <span
          key={`${label}-${value}`}
          className="inline-flex items-center rounded-full bg-blue-100 px-3 py-1 text-sm font-medium text-blue-800"
        >
          {label}: {formatFilterOptionLabel(value)}
          <button
            className="ml-2 text-blue-500 hover:text-blue-700 focus:outline-hidden"
            onClick={remove}
            aria-label={`Remove ${value} filter`}
            type="button"
          >
            &times;
          </button>
        </span>
      ))}
      <button
        className="ml-2 border-none bg-transparent p-0 text-sm text-blue-600 hover:underline"
        onClick={resetAll}
        type="button"
      >
        Reset filters
      </button>
    </div>
  );
};
